import React, {useEffect, useState} from 'react';
import { styled } from '@mui/material/styles';
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";

import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";

import {dataReloadDependants} from "../../redux/data/dataActions";

import {appSetAlert} from "../../redux/app/appActions";
import { axiosDelay } from "../../config/config";

import FormControl from "@mui/material/FormControl";
import Button from '@mui/material/Button';
import LinearProgress from '@mui/material/LinearProgress';
import useDataSource from "../../hooks/useDataSource";
import List from "@mui/material/List";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import {Card, CardContent, CardHeader, ListItemButton, Switch} from "@mui/material";
import {useTranslation} from "react-i18next";
import {getSecurityAccess} from "../../utilities/SecurityUtilities";

const PREFIX = 'EmissionsEditQAQCStatus';

const classes = {
    root: `${PREFIX}-root`,
    linearProgress: `${PREFIX}-linearProgress`,
    card: `${PREFIX}-card`,
    form: `${PREFIX}-form`,
    margin: `${PREFIX}-margin`,
    formEmbeddedActions: `${PREFIX}-formEmbeddedActions`,
    listContainer: `${PREFIX}-listContainer`
};

const Root = styled('div')((
    {
        theme
    }
) => ({
    [`&.${classes.root}`]: {
		width: '100%',
		height: '100%',
		//overflow: 'hidden'
	},

    [`& .${classes.linearProgress}`]: {
		height: '1px'
	},

    [`& .${classes.card}`]: {
		height: '100%',
		width: '100%'
	},

    [`& .${classes.form}`]: {
        // height: '300px'
    },

    [`& .${classes.margin}`]: {
		// margin: theme.spacing(1),
		// width: 'calc(100% - 16px)'
		display: 'inline-block',
		verticalAlign: 'middle'
    },

    [`& .${classes.formEmbeddedActions}`]: {
        // position: 'absolute',
        // bottom: '0px',
        // width: 'calc(100% - 32px)'
		display: 'inline-block',
		verticalAlign: 'middle'
    },

    [`& .${classes.listContainer}`]: {
        overflow: 'auto',
        // height: '350px',
        // marginTop: '8px'
    }
}));

export default function EmissionsEditQAQCStatusLayout({ configuration }) {
	const dispatch = useDispatch();
	const { t } = useTranslation();

	// App State
	const config = useSelector(state => state.config);
	const projectUserGroups = useSelector(state => state.user.projectUserGroups);
	const isThemeLight = useSelector(state => state.persist.themeLight);

    // Component State
	const [compConfig, setCompConfig] = useState(configuration);
	const [title, setTitle] = useState(compConfig.name?.title ? compConfig.name.title : '');
	const [subtitle, setSubTitle] = useState(compConfig.name?.subtitle ? compConfig.name.subtitle : '');
    const [qaqcStatusLoaded, setQAQCStatusLoaded] = useState(false);
	const [qaqcStatus, setQAQCStatus] = useState(null);
    const [checked, setChecked] = useState(false);
	const [isDisabled, setIsDisabled] = useState(true);
	const [cardHeaderStyle, setCardHeaderStyle] = useState({});
	const [cardContentStyle, setCardContentStyle] = useState({});

	const styles = compConfig?.element?.styles;
	const dataSourceName = compConfig?.dataSource?.name ? compConfig?.dataSource?.name : '';

	const dataSource = useDataSource(dataSourceName);

	const schema = yup.object().shape({
		validationapproved: yup.number()
	});

	const resolver = yupResolver(schema);
	const { register, handleSubmit, formState, formState: { errors } } = useForm({ resolver });

    // Component Configuration (compConfig) changed, reset state
	useEffect(() => {
		setTitle(compConfig.name?.title ? compConfig.name.title : '');
		setSubTitle(compConfig.name?.subtitle ? compConfig.name.subtitle : '');
	},[compConfig]);

	useEffect(() => {
		resizeCard();
	},[title, subtitle]);

	useEffect( () => {
		if (dataSource.data) {
			if (dataSource.data.length === 1) {
				const project = dataSource.data;
				const projectQAQCStatus = {
					projectid: project[0].projectid,
					status: project[0].validationapproved
				}

				const restricted = getSecurityAccess(dataSource.data[0].projectid, projectUserGroups, compConfig.security.restrict);

				if (restricted) {
					setIsDisabled(true);
				} else {
					setIsDisabled(false);
				}

				setChecked(projectQAQCStatus.status === true ? true : false);
				setQAQCStatus(projectQAQCStatus);
				setQAQCStatusLoaded(true);
			}
		}
	},[dataSource.data]);

	const handleToggle = () => {
		setChecked(!checked);
	};

    const onSubmit = dataToPost => {
		setTimeout(function () {
			const requestBody = {
				projectid: qaqcStatus.projectid,
				validationapproved: checked === true ? 1 : 0
			}

			// Set api url and body
			const apiUrl = "{0}projectvalidationupdate?db={1}".format(config.data.authentication.api, config.data.authentication.apiSource);

			// PUT request to update a row
			axios
				.post(apiUrl, requestBody)
				.then(function (response) {
					dispatch(appSetAlert(null, 'QA/QC Validation Status was successfully updated.', 'success', 10000));
					dispatch(dataReloadDependants(["vwQAQCDataValidationResults", "vwClientProjects", "vwQCQCSourceEFCount"]));
				})
				.catch(function (error) {
					console.log('**ERROR**', error);

					dispatch(appSetAlert('Whoops!', 'Something went seriously wrong. Please try again.', 'error', 10000));
				});

		}, JSON.parse(axiosDelay()));
    };

	const resizeCard = () => {

		const newCardHeaderStyle = Object.assign({}, {...styles?.cardHeader});
		const newCardContentStyle = Object.assign({}, {...styles?.cardContent
			,height: 'calc(100% - 49px)'
			,overflow: 'auto'
			,padding: '0px'}
		);

		if (title && subtitle) {
			// Default Style
		} else if (title) {
			// Title Only
			newCardHeaderStyle.height = '29px';
			newCardContentStyle.height = 'calc(100% - 29px)';
		} else if (subtitle) {
			// Subtitle Only
			newCardHeaderStyle.height = '29px';
			newCardContentStyle.height = 'calc(100% - 29px)';
		} else {
			// No title
			newCardHeaderStyle.height = '0px';
			newCardHeaderStyle.padding = '0px';
			newCardContentStyle.height = '100%';
		}
		setCardHeaderStyle(newCardHeaderStyle);
		setCardContentStyle(newCardContentStyle);
	}

    return (
        <Root className={classes.root}>
			<div className={classes.card}>
				{!qaqcStatusLoaded &&
					<LinearProgress className={classes.linearProgress}/>
				}
				<Card style={{height: '100%', boxShadow: 'none', ...styles?.card}}>
					<CardHeader action={null} className={classes.cardHeader} style={cardHeaderStyle}
								titleTypographyProps={{color: 'textPrimary', variant: 'subtitle2'}}
								title={t(title)}
								subheaderTypographyProps={{color: 'textSecondary', variant: 'body2'}}
								subheader={t(subtitle)}>
					</CardHeader>
					<CardContent style={cardContentStyle}>
						<form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
							{qaqcStatusLoaded && !isDisabled &&
								<React.Fragment>
									<FormControl variant="standard" className={classes.margin}>
										<div className={classes.listContainer}>
											<List className={classes.list}>
												<ListItemButton key={qaqcStatus.projectid} role={undefined} dense >
													<ListItemIcon>
														<Switch color="primary" display="inline-block" onChange={handleToggle} checked={checked}/>
													</ListItemIcon>
													<ListItemText id={`checkbox-list-label-${qaqcStatus.projectid}`} primary="Validation Approved?"/>
												</ListItemButton>
											</List>
										</div>
									</FormControl>

									<div className={classes.formEmbeddedActions}>
										<Button color={isThemeLight ? "primary" : "default"} type="submit"
												disabled={formState.isSubmitting}>
											Submit
										</Button>
									</div>
								</React.Fragment>
							}
						</form>
					</CardContent>
				</Card>
			</div>
		</Root>
    );
}
